// extracted by mini-css-extract-plugin
module.exports = {"hero":"Hero_hero__eu14V","heroCompetition":"Hero_heroCompetition__mWRcG","heroImage":"heroImage"};